import {BaseData} from './base/static_config_data/BaseData';
import {BackgroundData, IBackgroundData} from './field_config/BackgroundData';
import {ArrayWrap} from './base/static_config_data/ArrayWrap';
import {CardStackData, ICardStackData} from './field_config/CardStackData';
import {IStageData, StageData} from './field_config/StageData';
import {IPlayerData, PlayerData} from './field_config/PlayerData';
import {StaticData} from '../StaticData';

export class FieldData extends BaseData
{
    background: BackgroundData;
    card_stacks: ArrayWrap<CardStackData, ICardStackData>;
    placeholders: ArrayWrap<CardStackData, ICardStackData>;
    players: ArrayWrap<PlayerData, IPlayerData>;
    stage: StageData;

    constructor(public config: IFieldData) {
        super();

        this.background = new BackgroundData(config.background);
        this.stage = new StageData(config.stage);
        this.card_stacks = new ArrayWrap<CardStackData, ICardStackData>(CardStackData, config.card_stacks);
        this.placeholders = new ArrayWrap<CardStackData, ICardStackData>(CardStackData, config.placeholders);
        this.players = new ArrayWrap<PlayerData, IPlayerData>(PlayerData, config.players1 || []);
    }

    get width(): number {
        return this.config.width;
    }

    get height(): number {
        return this.config.height;
    }

    get showLogo(): boolean {
        return this.config.showLogo;
    }

    set showLogo(value: boolean) {
        this.config.showLogo = value;
    }

    get allPicturesUrls(): string[] {
        let urls: string[] = [];
        this.players.classes.forEach(player =>
            player.cards.classes.forEach(card => {
                this.checkAndAddUrl(urls, card.backface_src);
                this.checkAndAddUrl(urls, card.face_src);
            })
        );

        this.card_stacks.classes.forEach(stackdata =>
            stackdata.cards.classes.forEach(card => {
                this.checkAndAddUrl(urls, card.backface_src);
                this.checkAndAddUrl(urls, card.face_src);
            })
        );

        this.checkAndAddUrl(urls, this.background.image);

        return urls;
    }

    getCurrentPlayerData(): PlayerData {
        return this.getPlayerData(StaticData.playerId);
    }

    getPlayerData(playerId: string): PlayerData {
        return this.players.classes.find(player => player.id == playerId)!;
    }

    private checkAndAddUrl(urls: string[], url: string): void {
        if (!url) {
            return;
        }
        urls.includes(url) || urls.push(url);
    }
}

export interface IFieldData
{
    background: IBackgroundData;
    card_stacks: ICardStackData[];
    height: number;
    width: number;
    isPlayersCardsVisible: boolean;
    placeholders: ICardStackData[];
    players1: IPlayerData[];
    showLogo: boolean;
    stage: IStageData;
}
